import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { AssetsService } from '@sc/data-access-assets';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../button';
import { IconComponent } from '../../icon';

@Component({
  selector: 'sc-itinerary-main',
  styleUrls: ['./itinerary-main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="container">
      <div class="header">
        <button type="button" class="close-dialog-btn" (click)="onClose()">
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate
                : {
                    dialogTitle: 'ItineraryMapActionDialog.question' | translate
                  }
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </div>
      <h1
        mat-dialog-title
        id="itinerary-main-title-id"
        class="question sc-design-title-h2"
      >
        {{ 'ItineraryMapActionDialog.question' | translate }}
      </h1>

      <div class="actions">
        <sc-button
          class="cancel-btn"
          type="button"
          buttonType="mainWhite"
          (click)="onClose()"
          >{{ 'ItineraryMapActionDialog.cancelBtn' | translate }}</sc-button
        >
        <sc-button
          class="choice sc-design-button"
          type="button"
          (click)="onItineraryClick()"
        >
          {{ 'ItineraryMapActionDialog.googleMapChoice' | translate }}
        </sc-button>
      </div>
    </div>
  `,
  imports: [IconComponent, ButtonComponent, TranslateModule],
})
export class ItineraryMainComponent {
  @Output() closeEvent = new EventEmitter<void>();
  @Output() itineraryClick = new EventEmitter<void>();

  constructor(public assetsService: AssetsService) {}

  onClose() {
    this.closeEvent.emit();
  }

  onItineraryClick() {
    this.itineraryClick.emit();
  }
}
